import { CSSObject } from '@emotion/react';

const screen: CSSObject = {
  minHeight: '100%',
  background: '#f4f4f4',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
};

const section: CSSObject = {
  background: '#fff',
  padding: '20px 16px',
};

const name: CSSObject = {
  fontSize: 20,
  fontWeight: 700,
  marginBottom: 20,
};

const label: CSSObject = {
  fontSize: 14,
  color: '#48494F',
  marginBottom: 10,
};

const statRow: CSSObject = {
  display: 'flex',
  gap: 8,
};

const stat: CSSObject = {
  flex: 1,
  background: '#f4f4f4',
  borderRadius: 10,
  padding: '12px 14px',
  p: { fontSize: 12, color: '#48494F', marginBottom: 6 },
  strong: { fontSize: 20 },
};

const grid: CSSObject = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  rowGap: 16,
};

const item: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 6,
  img: {
    width: 56,
    height: 56,
    borderRadius: 14,
    objectFit: 'cover',
  },
  p: {
    fontSize: 12,
    color: '#48494F',
    textAlign: 'center',
    wordBreak: 'keep-all',
  },
};

const empty: CSSObject = {
  fontSize: 13,
  color: '#90929A',
  textAlign: 'center',
  padding: '16px 0',
};

const menuItem: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '14px 16px',
  fontSize: 14,
  color: '#48494F',
  borderBottom: '1px solid #f4f4f4',
  span: { color: '#90929A' },
};

export {
  screen,
  section,
  name,
  label,
  statRow,
  stat,
  grid,
  item,
  empty,
  menuItem,
};
